import {
  ChartContainer,
  ChartLegend,
  ChartLegendContent,
  ChartTooltip,
  ChartTooltipContent,
  type ChartConfig,
} from '@/components/ui/chart'
import { Bar, BarChart, XAxis, YAxis, CartesianGrid, LabelList } from 'recharts'

interface EmotionBarChartProps {
  valence: number
  arousal: number
  size?: 'small' | 'medium'
}

export const EmotionBarChart: React.FC<EmotionBarChartProps> = ({
  valence,
  arousal,
  size = 'medium',
}) => {
  // Prepare data with separate values for each metric
  const chartData = [
    {
      metric: 'Emotions',
      valence: valence,
      arousal: arousal,
    },
  ]

  const chartConfig = {
    valence: {
      label: 'Valence',
      color: 'var(--chart-1)',
    },
    arousal: {
      label: 'Arousal',
      color: 'var(--chart-2)',
    },
  } satisfies ChartConfig

  return (
    <div className="relative">
      <ChartContainer
        config={chartConfig}
        className={
          size === 'small'
            ? 'h-[100px] w-full aspect-auto'
            : 'h-[200px] w-full aspect-auto'
        }
      >
        <BarChart
          data={chartData}
          layout="vertical"
          margin={{ top: 0, right: 0, left: 0, bottom: 0 }}
          barSize={size === 'small' ? 10 : 20}
          barGap={5}
        >
          <CartesianGrid strokeDasharray="3 3" />
          <XAxis
            type="number"
            domain={[1, 100]}
            tickFormatter={value => value.toFixed(1)}
          />
          <YAxis type="category" dataKey="metric" width={60} hide />

          <ChartTooltip content={<ChartTooltipContent />} />
          <Bar dataKey="valence" fill="var(--color-valence)">
            <LabelList
              dataKey="valence"
              position="right"
              className="fill-foreground text-xs font-medium"
              formatter={(value: number) => value.toFixed(2)}
            />
          </Bar>
          <Bar dataKey="arousal" fill="var(--color-arousal)">
            <LabelList
              dataKey="arousal"
              position="right"
              className="fill-foreground text-xs font-medium"
              formatter={(value: number) => value.toFixed(2)}
            />
          </Bar>
          <ChartLegend content={<ChartLegendContent />} />
        </BarChart>
      </ChartContainer>
    </div>
  )
}
